export default __webpack_public_path__ + "static/media/1.76964ed2.jpg";